<div class="parties-info-container" fxLayout="row wrap" fxLayoutGap="10px">

  @if (partyType === 'P' && isAssignPrimaryRepBtnDisplayed) {
    <button mat-raised-button color="primary" class="spinner-black"
            (click)="addPartiesToTheCase('Primary Representative', partyType, -1)">
      <mat-icon>add</mat-icon>
      <div *appSpinner="this.savingDetails.saving"></div>
      Add Primary Rep
    </button>
  }

  @for (userInfo of partiesList; track userInfo; let index = $index) {
    <mat-card>
     <mat-card-content fxFlex="1 1 auto" >
        <div>
            <div *appSpinner="this.savingDetails.saving && this.savingDetails.index === index"></div>
            <!-- Name for both primary and secondary representative -->
              <span>
                {{ userInfo.first_Name }}&nbsp;
                  @if (userInfo.middle_initial) {
                    {{ userInfo.middle_initial }}&nbsp;
                    }
                    {{ userInfo.last_Name }}
              </span>
                 @if (userInfo.invitationStatus === 'INVITED') {
                  <span>&nbsp;<strong>(Pending)</strong></span>
                 }
            <br/>
          <span>{{ userInfo.phone_No }}</span><br>
          <span>{{ userInfo.email }}</span><br>
          <span>{{ userInfo.firm_Name }}</span><br>
          <span>{{ userInfo.address1 }}</span><br>
          @if (userInfo.address2) {
            <span>{{ userInfo.address2 }}<br></span>
          }
          <span>
            {{ userInfo.city }}&nbsp;{{ userInfo.state }}&nbsp;&nbsp;{{ userInfo.zip_Code }}<br>
            {{ userInfo.country }}
          </span>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">

          @if (index === 0) {
            @if (partyType === 'A' || partyType === 'SA') {

              @if (canAddAgencyBtnBeDisplayed) {
                <!-- Button for adding Agency Representative: display only for Agency Admin or GAO Admin -->
                <button mat-raised-button color="primary"
                        [disabled]="this.savingDetails.saving"
                        (click)="addPartiesToTheCase('Assign Agency Representative', partyType, index)">
                  <mat-icon>add</mat-icon>
                  Add Agency Rep
                </button>
              }
            } @else {
              <!-- Button for adding secondary representative: display only for primary protester or GAO admin -->
              @if ( ( (stateService.userRole === UserRole.GAO_Admin) && ((userInfo.role === 'PROTESTER') || (userInfo.role === 'INTERVENOR')) ) ||
                    (  ((stateService.userRole === UserRole.Protester) || (stateService.userRole === UserRole.Intervenor)) && (userInfo.user_Id === stateService.user.user_Id) ) &&
                    ( (userInfo.role === 'PROTESTER') || (userInfo.role === 'INTERVENOR') )
                ) {
                <button mat-raised-button color="primary"
                        [disabled]="this.savingDetails.saving"
                        (click)="this.onSecondaryRepAdd('Secondary Representative', partyType, index)">
                  <mat-icon>add</mat-icon>
                  Add 2nd Rep
                </button>
              }
            }
          }

          <!-- Spacer to push buttons to end of card when only single button -->
          <div></div>

          @if (partyType === 'A' || partyType === 'SA') {

            @if (canDeleteAgencyBtnBeDisplayed) {
              <!-- Delete Agency Representative -->
              <button mat-raised-button color="warn"
                      [disabled]="this.savingDetails.saving"
                      (click)="deletePartiesFromTheCase('Agency Attorney', userInfo, index)">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            }
          } @else {
            @if ( (protestInfo?.po === 'Y') &&
                  ( stateService.userRole === UserRole.GAO_Attorney || stateService.userRole === UserRole.GAO_Supervisor || stateService.userRole === UserRole.GAO_Admin) &&
                  !protestInfo?.viewOnly
                ) {
              @if (userInfo.po && (userInfo.po.trim() === 'N')) {
                <button mat-raised-button color="accent" class="spinner-black"
                        [disabled]="this.savingDetails.saving"
                        (click)="updateProtectiveOrder(userInfo, index)">
                  <mat-icon>add</mat-icon>
                  Add to PO
                </button>
              } @else if (userInfo.po && (userInfo.po.trim() === 'Y'))  {
                <button mat-raised-button color="warn" class="spinner-black"
                        [disabled]="this.savingDetails.saving"
                        (click)="updateProtectiveOrder(userInfo, index)">
                  <mat-icon>remove</mat-icon>
                  Remove from PO
                </button>
              }
            }

            <!-- Delete for Primary Representative -->
            @if ( (stateService.userRole === UserRole.GAO_Admin) && ((userInfo.role === 'PROTESTER') || (userInfo.role === 'INTERVENOR')) ) {
              <button mat-raised-button color="warn"
                      [disabled]="this.savingDetails.saving"
                      (click)="deletePartiesFromTheCase('Primary Representative', userInfo, index)">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            }

            <!-- Button for deleting secondary representative: display only for primary protester or GAO admin -->
            @if ( ( (stateService.userRole === UserRole.GAO_Admin) && (userInfo.role === 'SECONDARY PROTESTER') ) ||
                  (  (stateService.userRole === UserRole.Protester) && partiesList && (partiesList[0].user_Id === stateService.user.user_Id) && (userInfo.role === 'SECONDARY PROTESTER') )
                ) {
              <button mat-raised-button color="warn"
                      [disabled]="this.savingDetails.saving"
                      (click)="deletePartiesFromTheCase('Secondary Representative', userInfo, index)">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            }

            <!-- Button for deleting secondary representative: display only for primary intervenor or GAO admin -->
            @if ( ( (stateService.userRole === UserRole.GAO_Admin) && (userInfo.role === 'SECONDARY INTERVENOR') ) ||
            (  (stateService.userRole === UserRole.Intervenor) && partiesList && (partiesList[0].user_Id === stateService.user.user_Id) && (userInfo.role === 'SECONDARY INTERVENOR') )
              ) {
              <button mat-raised-button color="warn"
                      [disabled]="this.savingDetails.saving"
                      (click)="deletePartiesFromTheCase('Secondary Representative', userInfo, index)">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            }

          }

        </div>
      </mat-card-actions>
    </mat-card>
  }



</div>
